module.exports = __webpack_public_path__ + "img/LogoMinisterio.c43a3a78.png";